let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("easB0")).then(() => parcelRequire('gc97k'));